import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Mail, MapPin, ArrowUp, Facebook, Instagram, Linkedin } from 'lucide-react';
import { BRAND, NAV_LINKS } from '../data/siteData';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const goTo = (href) => {
    if (location.pathname !== '/') {
      navigate(`/${href}`);
      return;
    }
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="boost-footer" data-testid="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={BRAND.logo} alt="BOOST! Design & Marketing" className="footer-logo" />
          <p className="footer-slogan">{BRAND.slogan}</p>
          <a href={`mailto:${BRAND.email}`} className="footer-email" data-testid="footer-email">
            <Mail size={15} /> {BRAND.email}
          </a>
          <p className="footer-address" data-testid="footer-address">
            <MapPin size={15} /> {BRAND.address}
          </p>
          <div className="footer-social" data-testid="footer-social">
            <a href={BRAND.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="BOOST! on Facebook" className="footer-social-link" data-testid="footer-social-facebook">
              <Facebook size={18} />
            </a>
            <a href={BRAND.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="BOOST! on Instagram" className="footer-social-link" data-testid="footer-social-instagram">
              <Instagram size={18} />
            </a>
            <a href={BRAND.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="BOOST! on LinkedIn" className="footer-social-link" data-testid="footer-social-linkedin">
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <span className="footer-links-title">Navigate</span>
          {NAV_LINKS.map((l) => (
            <button key={l.href} onClick={() => goTo(l.href)} className="footer-link">
              {l.label}
            </button>
          ))}
          <Link to="/website-design-pricing" className="footer-link" data-testid="footer-pricing-link">
            Website Design Pricing
          </Link>
          <Link to="/work" className="footer-link" data-testid="footer-work-link">
            Our Work
          </Link>
          <Link to="/journal" className="footer-link" data-testid="footer-journal-link">
            The Journal
          </Link>
          <Link to="/case-studies/imprint-mis" className="footer-link" data-testid="footer-case-study-link">
            Case Study: Imprint MIS
          </Link>
          <Link to="/case-studies/temple-of-sound" className="footer-link" data-testid="footer-temple-case-study-link">
            Case Study: Temple of Sound
          </Link>
          <Link to="/case-studies/diamondbrite" className="footer-link" data-testid="footer-diamondbrite-case-study-link">
            Case Study: Diamondbrite
          </Link>
          <Link to="/case-studies/london-drumstick-co" className="footer-link" data-testid="footer-london-drumsticks-case-study-link">
            Case Study: London Drumstick Co.
          </Link>
        </div>

        <div className="footer-links">
          <span className="footer-links-title">Missions</span>
          <button onClick={() => goTo('#ai')} className="footer-link">AI Systems &amp; Workflows</button>
          <button onClick={() => goTo('#services')} className="footer-link">Design</button>
          <button onClick={() => goTo('#services')} className="footer-link">Web Design</button>
          <button onClick={() => goTo('#services')} className="footer-link">Social Media</button>
          <button onClick={() => goTo('#ads')} className="footer-link" data-testid="footer-ads-link">Google &amp; Meta Ads</button>
          <button onClick={() => goTo('#seo')} className="footer-link" data-testid="footer-seo-link">SEO &amp; GEO</button>
          <button onClick={() => goTo('#services')} className="footer-link">Automation</button>
        </div>

        <div className="footer-links">
          <span className="footer-links-title">Local</span>
          <Link to="/marketing-saffron-walden" className="footer-link" data-testid="footer-saffron-walden-link">
            Marketing Saffron Walden
          </Link>
          <Link to="/marketing-cambridge" className="footer-link" data-testid="footer-cambridge-link">
            Marketing Cambridge
          </Link>
          <Link to="/marketing-bishops-stortford" className="footer-link" data-testid="footer-bishops-stortford-link">
            Marketing Bishop's Stortford
          </Link>
          <Link to="/marketing-haverhill" className="footer-link" data-testid="footer-haverhill-link">
            Marketing Haverhill
          </Link>
          <Link to="/marketing-great-dunmow" className="footer-link" data-testid="footer-great-dunmow-link">
            Marketing Great Dunmow
          </Link>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} BOOST! Design &amp; Marketing. All systems nominal.</span>
        <button className="footer-top-btn" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} data-testid="back-to-top">
          Back to top <ArrowUp size={14} />
        </button>
      </div>
    </footer>
  );
}
